import React from "react";

// Bottom-right dark toast; the caller decides when it shows and hides.
export default function ToastMessage({ message, onClose }) {
  return (
    <div
      className="toast align-items-center text-bg-dark fade show position-fixed bottom-0 end-0 p-3"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          onClick={onClose}
        ></button>
      </div>
    </div>
  );
}
